import React from "react";
import useApi from "../hooks/useApi";
import Layout from "../layouts/Default";
import Designer from "../parts/Designers/Designer";
import Select from "../components/selects/Select";
import NoItems from "../parts/NoItems";
import Loader from "../components/loaders/Loader";
import TypesContext from "../contexts/types";
import Pager from "../parts/Pager";

const select = (state, selection) => {
  if (state && state.value && state.value === selection.value) return null;
  else return selection;
};

export default () => {
  const {
    skills: fetchedSkills,
    experiences: fetchedExperiences,
    regions
  } = React.useContext(TypesContext);
  const [skill, setSkill] = React.useReducer(select);
  const [experience, setExperience] = React.useReducer(select);
  const [region, setRegion] = React.useReducer(select);
  const { data: designers, loading: loadingDesigner } = useApi(
    "/users?role=designer"
  );

  const skills = fetchedSkills
    ? fetchedSkills.map(({ name, id }) => ({
        label: name,
        value: id
      }))
    : [];

  const experiences = Object.entries(fetchedExperiences).map(
    ([value, label]) => ({
      value,
      label
    })
  );

  const filteredDesigners = designers
    ? designers.filter(designer => {
        if (
          skill &&
          (!designer.skill || !designer.skill.find(id => id === skill.value))
        )
          return false;
        if (experience && designer.level !== experience.value) return false;
        if (region && !designer.city.includes(region.value)) return false;
        return true;
      })
    : [];

  return (
    <Layout noPadding title="Designers">
      <div className="pDesigners">
        <h3 className="pDesigners_count">
          {designers ? designers.length + " designers" : "0 designer"}
        </h3>
        <div className="pDesigners_filters">
          <Select
            placeholder="Skills"
            options={skills}
            selected={skill}
            setSelected={setSkill}
            width="94px"
            adaptable
          />
          <Select
            placeholder="Experience"
            options={experiences}
            selected={experience}
            setSelected={setExperience}
            width="136px"
            adaptable
          />
          <Select
            placeholder="Region"
            options={regions}
            selected={region}
            setSelected={setRegion}
            width="106px"
            adaptable
          />
        </div>
        <div>
          {designers && (
            <Pager
              items={filteredDesigners}
              Component={Designer}
              listClassname="pDesigners_list"
            />
          )}
          {loadingDesigner && <Loader />}
          {!designers ||
            designers.length === 0 ||
            ((!filteredDesigners || filteredDesigners.length === 0) && (
              <NoItems />
            ))}
        </div>
      </div>
    </Layout>
  );
};
